var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[_c('router-view',{attrs:{"name":"header"}})],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('transition',{attrs:{"name":"trans"}},[_c('keep-alive',{attrs:{"include":"userInfo,memberAward,addMember"}},[_c('router-view')],1)],1)],1),_vm._v(" "),(_vm.loadingStatus)?_c('loading',{}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2beb5e96","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 